import _regeneratorRuntime from "@babel/runtime/regenerator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { __awaiter } from "tslib";
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import classNames from 'classnames';
import DotLoading from '../dot-loading';
import { mergeProps } from '../../utils/with-default-props';
import { withNativeProps } from '../../utils/native-props';
import { isPromise } from '../../utils/validate';
var classPrefix = "adm-button";
var defaultProps = {
  color: 'default',
  fill: 'solid',
  block: false,
  loading: false,
  loadingIcon: /*#__PURE__*/React.createElement(DotLoading, {
    color: 'currentColor'
  }),
  type: 'button',
  shape: 'default',
  size: 'middle'
};
export var Button = /*#__PURE__*/forwardRef(function (p, ref) {
  var _classNames;

  var props = mergeProps(defaultProps, p);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      innerLoading = _useState2[0],
      setInnerLoading = _useState2[1];

  var nativeButtonRef = useRef(null);
  var loading = props.loading === 'auto' ? innerLoading : props.loading;
  var disabled = props.disabled || loading;
  useImperativeHandle(ref, function () {
    return {
      get nativeElement() {
        return nativeButtonRef.current;
      }

    };
  });

  var handleClick = function handleClick(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var promise;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (props.onClick) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              promise = props.onClick(e);

              if (!isPromise(promise)) {
                _context.next = 15;
                break;
              }

              _context.prev = 4;
              setInnerLoading(true);
              _context.next = 8;
              return promise;

            case 8:
              setInnerLoading(false);
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              setInnerLoading(false);
              throw _context.t0;

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 11]]);
    }));
  };

  return withNativeProps(props, /*#__PURE__*/React.createElement("button", {
    ref: nativeButtonRef,
    type: props.type,
    onClick: handleClick,
    className: classNames(classPrefix, props.color ? "".concat(classPrefix, "-").concat(props.color) : null, (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-block"), props.block), _defineProperty(_classNames, "".concat(classPrefix, "-disabled"), disabled), _defineProperty(_classNames, "".concat(classPrefix, "-fill-outline"), props.fill === 'outline'), _defineProperty(_classNames, "".concat(classPrefix, "-fill-none"), props.fill === 'none'), _defineProperty(_classNames, "".concat(classPrefix, "-mini"), props.size === 'mini'), _defineProperty(_classNames, "".concat(classPrefix, "-small"), props.size === 'small'), _defineProperty(_classNames, "".concat(classPrefix, "-large"), props.size === 'large'), _defineProperty(_classNames, "".concat(classPrefix, "-loading"), loading), _classNames), "".concat(classPrefix, "-shape-").concat(props.shape)),
    disabled: disabled,
    onMouseDown: props.onMouseDown,
    onMouseUp: props.onMouseUp,
    onTouchStart: props.onTouchStart,
    onTouchEnd: props.onTouchEnd
  }, loading ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-loading-wrapper")
  }, props.loadingIcon, props.loadingText) : /*#__PURE__*/React.createElement("span", null, props.children)));
});